import { MonetateExperience } from '@JohnLewisPartnership/experiments-utils';

const getSkuElement = (): Element | null => {
    return window.document.querySelector(`#add-to-wish-list-esi`);
};

export const getSkuId = (): string => {
    return getSkuElement()?.getAttribute('data-sku') ?? '';
};

export const getSkuSelected = (): boolean => {
    return getSkuElement()?.getAttribute('data-sku-selected') !== 'false' ?? false;
};

export const getProductDetails = (): string => {
    const addToWishlistElement = getSkuElement();
    return addToWishlistElement ? (addToWishlistElement.getAttribute('data-product-details') as string) : '';
};

export const getProductMetadata = (): string => {
    const addToWishlistElement = getSkuElement();
    return addToWishlistElement ? (addToWishlistElement.getAttribute('data-product-metadata') as string) : '';
};

export const getExperiences = (): MonetateExperience[] => {
    const addToWishlistElement = getSkuElement();

    const encodedExperiences = addToWishlistElement?.getAttribute('data-experiences');

    if (encodedExperiences) {
        try {
            const stringifiedExperiences = window.atob(encodedExperiences);
            return JSON.parse(stringifiedExperiences);
        } catch {
            //silently swallow
        }
    }
    return [];
};
